import * as yup from 'yup';

export interface IFormValues {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const validationSchema = yup.object({});
